import React, { createContext, useContext } from 'react';
import { useDocumentUploadBanner } from '../hooks/useDocumentUploadBanner';

type DocumentUploadBannerContextType = ReturnType<
  typeof useDocumentUploadBanner
>;

const DocumentUploadBannerContext =
  createContext<DocumentUploadBannerContextType | null>(null);

export const useDocumentUploadBannerContext =
  (): DocumentUploadBannerContextType => {
    const context = useContext(DocumentUploadBannerContext);
    if (!context) {
      throw new Error(
        'useDocumentUploadBannerContext must be used within a DocumentUploadBannerProvider'
      );
    }
    return context;
  };

interface DocumentUploadBannerProviderProps {
  children: React.ReactNode;
  bannerState: DocumentUploadBannerContextType;
}

export const DocumentUploadBannerProvider: React.FC<
  DocumentUploadBannerProviderProps
> = ({ children, bannerState }) => {
  return (
    <DocumentUploadBannerContext.Provider value={bannerState}>
      {children}
    </DocumentUploadBannerContext.Provider>
  );
};
